import { nextTick } from "vue";
import { KM_TO_MILES } from "@/Util";


export function sendResizeEventNextTick() {
	nextTick(() => {
		sendResizeEvent();
	});
}

/**
 * Browser resize event that even IE understands.
 */
export function sendResizeEvent() {
	const resizeEvent = window.document.createEvent('UIEvents');
	//@ts-ignore
	resizeEvent.initUIEvent('resize', true, false, window, 0);
	window.dispatchEvent(resizeEvent);
}

export function locationColor() {
	return getComputedStyle(document.documentElement)
		.getPropertyValue('--location-color');
}

export function interpolate(value: number, min: number, max: number, toMin: number, toMax: number) {
	const fraction = Math.min(1, Math.max(0, (value - min) / (max - min)));
	return toMin + fraction * (toMax - toMin);
}

export function copyLocProps(source: Object, sourceProp: string, langSuffixes: string[], destProp?: string) {
	const ret = {};
	if (!destProp) destProp = sourceProp;

	if (!source) return ret;

	for (const suffix of langSuffixes) {
		ret[destProp + suffix] = source[sourceProp + suffix];
	}
	return ret;
}

export function distanceString(distanceInKm: number | undefined, unit: "km" | "mi") {

	if (distanceInKm === undefined) {
		return ""
	}

	if (unit == "mi") {
		distanceInKm /= KM_TO_MILES
	}
	distanceInKm = Math.round(distanceInKm * 10) / 10
	return `${distanceInKm} ${unit}`
}

export function elevationString(elevationInM: number, unit: "km" | "mi") {
	if (unit == "mi") {
		elevationInM *= 3.2808399
	}
	elevationInM = Math.round(elevationInM)
	return `${elevationInM} ${unit == 'km' ? 'm' : 'ft'}`
}

export function sleep(ms: number) {
	return new Promise(resolve => setTimeout(resolve, ms));
}